module.exports = __webpack_public_path__ + "img/pdf.b7560cbb.png";